import Vue from 'vue'
import Router from 'vue-router'

import home from '@/views/home'





const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router)



const routes =[
      {
      path: '/',
      redirect:'/home'
      },
     {
      path: '/home',
      name: 'home',
      component: () => import('../views/home.vue'),
     },
     {
      path: '/digit',
      name: 'digit',
      component: () => import('../views/digit.vue'),
     },
     {
      path: '/leave',
      name: 'leave',
      component: () => import('../views/leave.vue'),
     },
     {
      path: '/payment',
      name: 'payment',
      component: () => import('../views/payment.vue'),
     },




  ]
  const router = new Router({
    mode: 'history',
    routes
  })

  export default router





// WEBPACK FOOTER //
// ./src/router/index.js